import ScientificCollaborationProgram from './ScientificCollaborationProgram';

export default ScientificCollaborationProgram;